// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import api from "../../../api/axios";

// const GuestDatabase = () => {
//   const [guests, setGuests] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadGuests();
//   }, []);

//   const loadGuests = async () => {
//     try {
//       const res = await api.get("/pms/guests");

//       const formatted = (res.data?.data || []).map((g) => ({
//         id: g.id,
//         guest_name: g.name || `${g.first_name} ${g.last_name}`,
//         email: g.email || "N/A",
//         mobile: g.mobile_no || g.phone || "N/A",
//         vip_status: g.is_vip ? "Yes" : "No",
//       }));

//       setGuests(formatted);
//     } catch (err) {
//       console.error("Failed to load guests", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <p>Loading Guest Database...</p>;

//   return (
//     <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
//       <div className="row g-3">
//         <div className="col-sm-12">
//           <h3 className="fw-bold mb-0">Guest Database</h3>
//         </div>

//         <div className="col-sm-12">
//           <div className="card">
//             <div className="card-body">
//               <div className="table-responsive">
//                 <table className="table table-hover">
//                   <thead>
//                     <tr className="small text-uppercase">
//                       <th></th>
//                       <th>Guest Name</th>
//                       <th>Email</th>
//                       <th>Mobile</th>
//                       <th>VIP Status</th>
//                       <th></th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {guests.map((data, index) => (
//                       <tr key={index}>
//                         <td>
//                           <div className="form-check">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                             />
//                           </div>
//                         </td>

//                         <td>{data.guest_name}</td>
//                         <td>{data.email}</td>
//                         <td>{data.mobile}</td>
//                         <td>{data.vip_status}</td>

//                         <td>
//                           <div className="dropdown">
//                             <i
//                               className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle"
//                               data-bs-toggle="dropdown"
//                               aria-expanded="false"
//                             ></i>

//                             <ul className="dropdown-menu">
//                               <li>
//                                 <Link
//                                   to={`/edit-guest-database/${data.id}`}
//                                   className="dropdown-item"
//                                 >
//                                   <i className="bi bi-pencil-square me-2"></i>
//                                   Edit
//                                 </Link>
//                               </li>

//                               <li>
//                                 <button className="dropdown-item">
//                                   <i className="bi bi-trash me-2"></i>Delete
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GuestDatabase;


// GuestList.jsx
import React, { useEffect, useState } from "react";
import AddGuest from "./Components/AddGuest";
import EditGuest from "./Components/EditGuest";
import GuestTable from "./Components/GuestTable";
import Swal from "sweetalert2";
import api from "../../../api/axios";
import BackButton from "../Hotels/Components/BackButton";

const GuestList = () => {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedGuest, setSelectedGuest] = useState(null);

  const fetchGuests = async () => {
    setLoading(true);
    try {
      const res = await api.get("/pms/guests");
      setGuests(res.data.data || res.data || []);
    } catch (err) {
      console.error("Failed to fetch guests:", err);
      setGuests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGuests();
  }, []);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete guest?",
      text: "This will permanently delete the guest record.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete",
    });

    if (confirm.isConfirmed) {
      try {
        await api.delete(`/pms/guests/${id}`);
        Swal.fire({ icon: "success", title: "Deleted", timer: 1200, showConfirmButton: false });
        fetchGuests();
      } catch (err) {
        console.error("Delete failed:", err);
        Swal.fire({ icon: "error", title: "Delete failed", text: err.response?.data?.message || "Something went wrong" });
      }
    }
  };

  const openEdit = (guest) => {
    setSelectedGuest(guest);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Guests</h3>
            <button className="btn btn-dark" onClick={() => setIsAddOpen(true)}>Add Guest</button>
          </div>
        </div>

        <div className="card mt-3">
          <div className="card-body">
            <GuestTable data={guests} loading={loading} onEdit={openEdit} onDelete={handleDelete} />
          </div>
        </div>

        <AddGuest open={isAddOpen} onClose={() => setIsAddOpen(false)} onAdded={fetchGuests} />
        <EditGuest open={isEditOpen} onClose={() => setIsEditOpen(false)} guest={selectedGuest} onUpdated={fetchGuests} />
      </div>
    </div>
  );
};

export default GuestList;
